import React from 'react';
import { LoginManager } from '../../../services/LoginManager';


function LoginButton() {
  const startLogin = () => {
    
    let manager = new LoginManager();
    
    manager.signin();
  };

  return (
    <div>
      <button className="login-button" style={{ width:"100%" }} onClick={startLogin}>
        Login
      </button>
    </div>
  );
}

export default LoginButton;
